/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-07 15:20:46
 */ 
import axios from '../axios'

/* 
 * 日志管理模块
 */

// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/admin/service/sys_log_getList',
        method: 'post',
        data
    })
}   


// WEBPACK FOOTER //
// ./src/http/moudules/log.js